import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PageModal from '../common/PageModal'
import SimpleButton from '../common/SimpleButton'
import { toast } from '../common/Toast'
import { postSparePartsRequestMissingItem } from '../../utils/requests/spareparts'

const RequestMissingItemModal = ({ selectedModel, onClose }) => {
  const { t } = useTranslation()
  const [partName, setPartName] = useState('')
  const [partNumber, setPartNumber] = useState('')
  const [comments, setComments] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const isSubmitDisabled = isSubmitting || (!partName.trim() && !comments.trim() && !partNumber.trim())

  const handleSubmit = async () => {
    setIsSubmitting(true)

    try {
      await postSparePartsRequestMissingItem({
        modelName: selectedModel.name || '',
        partNumber: partNumber.trim() || '',
        partDescription: partName.trim() || '',
        comments: comments.trim() || '',
      })
      toast.success(t('spareparts.request-submitted-successfully'))
      onClose()
    } catch (error) {
      toast.error(t('error.something_wrong'))
    } finally {
      setIsSubmitting(false)
    }
  }

  const footerContent = (
    <>
      <SimpleButton className="cancel-button" onClick={onClose} disabled={isSubmitting}>
        {t('cancel')}
      </SimpleButton>
      <SimpleButton className="submit-button" onClick={handleSubmit} disabled={isSubmitDisabled}>
        {t('submit')}
      </SimpleButton>
    </>
  )

  return (
    <PageModal
      toggle
      onToggle={onClose}
      title={t('spareparts.request-missing-sparepart')}
      footerContent={footerContent}
      className="request-missing-item-page-modal"
    >
      <div className="request-modal-form">
        {selectedModel && (
          <div className="form-group">
            <label className="form-label">{t('model')}</label>
            <input type="text" className="form-input" value={selectedModel.name} disabled />
          </div>
        )}
        <div className="form-group">
          <label className="form-label">{t('part_number')}</label>
          <input
            type="text"
            className="form-input"
            value={partNumber}
            onChange={(e) => setPartNumber(e.target.value)}
            placeholder={t('spareparts.part-number-placeholder')}
          />
        </div>
        <div className="form-group">
          <label className="form-label">{t('spareparts.part-name')}</label>
          <input
            type="text"
            className="form-input"
            value={partName}
            onChange={(e) => setPartName(e.target.value)}
            placeholder={t('spareparts.part-name-placeholder')}
          />
        </div>
        <div className="form-group">
          <label className="form-label">{t('dealer-portal.comments')}</label>
          <textarea
            className="form-textarea"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            placeholder={t('spareparts.request-missing-part-comments-placeholder')}
            rows={4}
          />
        </div>
      </div>
    </PageModal>
  )
}

export default RequestMissingItemModal
